import React from 'react';
import CadreBox from '../elements/cadre_box';

import c21 from '../images/cadre_visuel/C2/C229251.jpg';
import c22 from '../images/cadre_visuel/C2/C229253.jpg';
import c23 from '../images/cadre_visuel/C2/C230251.jpg';
import c24 from '../images/cadre_visuel/C2/C230253.jpg';
import c25 from '../images/cadre_visuel/C2/C232251.jpg';
import c26 from '../images/cadre_visuel/C2/C232253.jpg';
import c27 from '../images/cadre_visuel/C2/C240251.jpg';
import c28 from '../images/cadre_visuel/C2/C240253.jpg';
import c29 from '../images/cadre_visuel/C2/C242251.jpg';
import c210 from '../images/cadre_visuel/C2/C242253.jpg';
import c211 from '../images/cadre_visuel/C2/C250251.jpg';
import c212 from '../images/cadre_visuel/C2/C250253.jpg';
import c213 from '../images/cadre_visuel/C2/C264251.jpg';
import c214 from '../images/cadre_visuel/C2/C264253.jpg';
import c215 from '../images/cadre_visuel/C2/C270251.jpg';
import c216 from '../images/cadre_visuel/C2/C270253.jpg';
import c217 from '../images/cadre_visuel/C2/C280251.jpg';
import c218 from '../images/cadre_visuel/C2/C280253.jpg';
import c219 from '../images/cadre_visuel/C2/C2_10_x_15.jpg';
import c220 from '../images/cadre_visuel/C2/C2_18_x_24.jpg';
import c221 from '../images/cadre_visuel/C2/C2_50_x_50.jpg';
import c222 from '../images/cadre_visuel/C2/C2_70_x_100.jpg';
import c223 from '../images/cadre_visuel/C2/C2_18_x_24_Blanc.jpg';
import c224 from '../images/cadre_visuel/C2/C2_21_x_29.7_Blanc.jpg';
import c225 from '../images/cadre_visuel/C2/C2_24_x_30_Blanc.jpg';
import c226 from '../images/cadre_visuel/C2/C2_29.7_x_42_Blanc.jpg';
import c227 from '../images/cadre_visuel/C2/C2_30_x_30_Blanc.jpg';
import c228 from '../images/cadre_visuel/C2/C2_30_x_40_Blanc.jpg';
import c229 from '../images/cadre_visuel/C2/C2_30_x_45_Noir.jpg';
import c230 from '../images/cadre_visuel/C2/C2_40_x_50_Blanc.jpg';
import c231 from '../images/cadre_visuel/C2/C2_50_x_70_Blanc.jpg';


const CadresC2 = () => (
	<div>
		<section className="section">
			<div className="container">
				<div className="notification is-info centered-content">
					<h2 className="title">Cadres C2</h2>
					<p>Cadres en aluminium à la fois sobres et modernes.</p>
					<p>Une collection qui propose des pris attractifs.</p>
					<p>Disponibles en noir mat brossé et en gris mat brossé.</p>
				</div>
			</div>
		</section>
		<section className="section">
			<div className="columns">
				<div className="column is-3">
					<CadreBox src={c219} alt="alpha" price="10,80 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c220} alt="alpha" price="14,80 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c223} alt="alpha" price="14,80 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c21} alt="alpha" price="17,90 €"/>
				</div>
			</div>
			<div className="columns">
				<div className="column is-3">
					<CadreBox src={c22} alt="alpha" price="17,90 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c224} alt="alpha" price="17,90 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c23} alt="alpha" price="18,60 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c24} alt="alpha" price="18,60 €"/>
				</div>
			</div>
			<div className="columns">
				<div className="column is-3">
					<CadreBox src={c225} alt="alpha" price="18,60 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c25} alt="alpha" price="22,20 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c26} alt="alpha" price="22,20 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c227} alt="alpha" price="22,20 €"/>
				</div>
			</div>
			<div className="columns">
				<div className="column is-3">
					<CadreBox src={c29} alt="alpha" price="26,70 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c210} alt="alpha" price="26,70 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c226} alt="alpha" price="26,70 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c27} alt="alpha" price="27,60 €"/>
				</div>
			</div>
			<div className="columns">
				<div className="column is-3">
					<CadreBox src={c28} alt="alpha" price="27,60 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c228} alt="alpha" price="27,60 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c229} alt="alpha" price="32,50 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c230} alt="alpha" price="32,50 €"/>
				</div>
			</div>
			<div className="columns">
				<div className="column is-3">
					<CadreBox src={c211} alt="alpha" price="34,00 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c212} alt="alpha" price="34,00 €"/>
				<div className="column is-3">
					<CadreBox src={c221} alt="alpha" price="37,90 €"/>
				</div>
				</div>
				<div className="column is-3">
					<CadreBox src={c213} alt="alpha" price="38,50 €"/>
				</div>
				
			</div>
			<div className="columns">
				<div className="column is-3">
					<CadreBox src={c214} alt="alpha" price="38,50 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c215} alt="alpha" price="43,90 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c216} alt="alpha" price="43,90 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c231} alt="alpha" price="43,90 €"/>
				</div>
			</div>
			<div className="columns is-centered">
				<div className="column is-3">
					<CadreBox src={c217} alt="alpha" price="53,50 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c218} alt="alpha" price="53,50 €"/>
				</div>
				<div className="column is-3">
					<CadreBox src={c222} alt="alpha" price="66,50 €"/>
				</div>
			</div>
		</section>
	</div>
);

export default CadresC2;